if (typeof window === 'undefined') {

    discovery(
        module.exports,
        require('./socialPosts.js'),
        require('./dimensions.js'),
        require('./aggregates.js'),
        require('./expansions.js'),
        require('../../utils/timePeriod.js'),
        require('lodash')
    );

} else {

    discovery(
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics.expansions,
        RivalIQ.utils.timePeriod,
        window._
    );
}

function discovery(metrics, socialPostsMetrics, dimensions, aggregates, expansions, timePeriodUtils, _) {

    'use strict';

    function getModels() {
        return (typeof window === 'undefined' ? require('../metric.js') : RivalIQ.models);
    }

    function getSocialPostModels() {
        return (typeof window === 'undefined' ? require('../post.js') : RivalIQ.models);
    }

    const DiscoveryBaseMetric = {
        build: function () {
            const me = this;
            const definition = socialPostsMetrics.getMetricBase().build.apply(me, arguments);
            definition.data = me.data;
            return definition;
        },

        fetch: function (attrs) {
            const me = this;

            attrs = _.extend(me.resolvedAttributes(), attrs);
            return _.result(me, 'metricsCollection')
                .fetch(attrs)
                .then(function (data) {
                    const attributes = _.extend({}, me.resolvedAttributes());
                    const models = getModels();

                    const metric = new models.Metric(attributes, data);
                    metric.unexpandedAttributes = me.unexpandedAttributes;
                    return metric;
                });
        },

        getOrderBy: function () {
            const me = this;
            return me.get('property');
        },

        serialize: function () {
            const me = this;
            return me.toJSON();
        },

        getSubmetricValue: function (property, submetric) {
            const me = this;
            if (_.includes(['influencer'], property)) {
                return submetric;
            } else if (_.includes(['post'], property)) {
                const socialPostModels = getSocialPostModels();
                return new socialPostModels.DiscoveryPost(_.defaults({
                    channel: me.get('channel')
                }, submetric));
            }
        },

        // override this as we don't want the special casing of the name metric from the base class.
        getCellView: function (data) {
            const me = this;

            return me.cellView || me.byField('cellView', data);
        }
    };

    metrics.Discovery = _.extend({}, socialPostsMetrics.getMetricBase(), DiscoveryBaseMetric, {

        metricsCollection: function () {
            return RivalIQ.apps.Discovery.data.discovery;
        }

    });
}
